<template>
  <div
    class="mb-2 grid gap-2 [&_h1]:!font-light [&_h2]:!font-light [&_h3]:!font-light [&_h4]:!font-light [&_h5]:!font-light [&_p]:my-4"
    v-html="mgnlProps.content"
  />
</template>

<script lang="ts" setup>
import { TextBuilder, WrapperProps } from '~/components/Shared/MagnoliaElements/Text/Text.model';

const props = defineProps(WrapperProps);
const mgnlProps = TextBuilder.build(props);
</script>
